import React from "react";
import TableRow from "src/components/Shared/Table/TableRow";
import { formatDate } from "src/helpers/formatDate";

const LogEntry = ({ data }) => {
  return (
    <TableRow keyId={data?._id}>
      <td className="break-word block w-[300px]  whitespace-pre-wrap px-6 py-0 pt-3 text-sm text-gray-500 sm:table-cell sm:w-auto sm:py-3.5">
        <div className="flex flex-col items-start  gap-y-1">
          <div className="text-gray-700">{`${data?.user_name || "User"}`}</div>
          <div className="text-xs">{data?.user_email}</div>
        </div>
      </td>
      <td className="break-word block w-full whitespace-pre-wrap px-3 py-0 pt-3 text-sm text-gray-500 sm:table-cell sm:w-auto sm:py-3.5">{data?.client?.company_name}</td>
      <td className="break-word block w-full whitespace-pre-wrap px-3 py-0 pt-3 text-sm text-gray-500 sm:table-cell sm:w-auto sm:py-3.5">
        <div className="hidden text-gray-900 2xl:block">{formatDate(data?.created_at, "LLLL")}</div>
        <div className="flex flex-col text-gray-900 2xl:hidden">
          {formatDate(data?.created_at, "MM/DD/YYYY")} <span className="text-gray-400">{formatDate(data?.created_at, "h:mm:ssA")}</span>
        </div>
      </td>
    </TableRow>
  );
};

export default LogEntry;
